var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.model.getRootCss(_vm.container),
      style: { maxWidth: _vm.model.progressWidth },
      attrs: {
        role: "progressbar",
        "aria-valuemin": "0",
        "aria-valuemax": "100",
        "aria-label": "progress",
      },
    },
    [
      _vm.canShowHeader
        ? _c("div", { class: _vm.survey.css.progressButtonsHeader }, [
            _c(
              "div",
              {
                class: _vm.survey.css.progressButtonsPageTitle,
                attrs: { title: _vm.model.headerText },
              },
              [_vm._v(_vm._s(_vm.model.headerText))]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { class: _vm.css.progressButtonsContainer }, [
        _c("div", {
          class: _vm.model.getScrollButtonCss(_vm.hasScroller, true),
          attrs: { role: "button" },
          on: {
            click: function ($event) {
              return _vm.clickScrollButton(true)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "progressButtonsListContainer",
            class: _vm.css.progressButtonsListContainer,
          },
          [
            _c(
              "ul",
              { class: _vm.css.progressButtonsList },
              _vm._l(_vm.survey.visiblePages, function (page, index) {
                return _c(
                  "li",
                  {
                    key: "listelement" + index,
                    class: _vm.model.getListElementCss(index),
                    attrs: {
                      "data-page-number": _vm.model.getItemNumber(page),
                    },
                    on: {
                      click: function ($event) {
                        _vm.model.isListElementClickable(index)
                          ? _vm.model.clickListElement(page)
                          : null
                      },
                    },
                  },
                  [
                    _c("div", { class: _vm.css.progressButtonsConnector }),
                    _vm._v(" "),
                    _vm.canShowItemTitles
                      ? _c(
                          "div",
                          {
                            class: _vm.css.progressButtonsPageTitle,
                            attrs: { title: page.renderedNavigationTitle },
                          },
                          [
                            _c("survey-string", {
                              attrs: { locString: page.locNavigationTitle },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.canShowItemTitles
                      ? _c(
                          "div",
                          {
                            class: _vm.css.progressButtonsPageDescription,
                            attrs: {
                              title: page.locNavigationDescription.renderedHtml,
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  page.locNavigationDescription.renderedHtml
                                ) +
                                "\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { class: _vm.css.progressButtonsButton }, [
                      _c("div", {
                        class: _vm.css.progressButtonsButtonBackground,
                      }),
                      _c("div", {
                        class: _vm.css.progressButtonsButtonContent,
                      }),
                      _c("span", [
                        _vm._v(_vm._s(_vm.model.getItemNumber(page))),
                      ]),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", {
          class: _vm.model.getScrollButtonCss(_vm.hasScroller, false),
          attrs: { role: "button" },
          on: {
            click: function ($event) {
              return _vm.clickScrollButton(false)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _vm.canShowFooter
        ? _c("div", { class: _vm.survey.css.progressButtonsFooter }, [
            _c(
              "div",
              {
                class: _vm.survey.css.progressButtonsPageTitle,
                attrs: { title: _vm.model.footerText },
              },
              [_vm._v(_vm._s(_vm.model.footerText))]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }